<script setup>
import { appValidator } from '@pfsc/core/utils/validator';
import useVuelidate from '@vuelidate/core';
import {
  onMounted,
  ref,
} from 'vue';
import AppDatePicker from '../app-date-picker.vue';

const props = defineProps({
  modelValue: {
    type: [Date, String],
    required: false,
  },
});

const emits = defineEmits(['update:model-value']);

const rules = {
  expiredDate: {
    required: appValidator.required,
    isValidDate: appValidator.validDate,
  },
};
const form = ref({
  expiredDate: null,
});

const v$ = useVuelidate(rules, form);

/**
 * Handle update expired date.
 * @param {Date} value Date
 */
function onUpdateExpiredDate(value) {
  form.value.expiredDate = value;

  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  emits('update:model-value', value);
}

onMounted(() => {
  if (props.modelValue != null) {
    form.value.expiredDate = props.modelValue;
  }
});
</script>
<template>
  <v-form :class="$style.expiredDate">
    <app-date-picker
      hide-details
      :model-value="modelValue"
      :error-messages="v$.expiredDate.$errors.map((e) => e.$message)"
      @update:model-value="onUpdateExpiredDate"
    />
  </v-form>
</template>
<style module>
.expiredDate {
  width: 150px;
}
</style>
